import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

interface CarVariant {
    name: string;
    image: string;
    price: number;
}

interface CarModel {
    model: string;
    variants: CarVariant[];
}

@customElement('car-selector')
export class CarSelector extends LitElement {
    @property({ type: String, reflect: true }) selected = 'Forester';
    @property({ type: String }) selectId = '';
    @property({ type: Array }) cars: CarModel[] = [];

    createRenderRoot() {
        return this;
    }

    render() {
        return html`
            <select
                id="${this.selectId}" 
                class="car-model w-full p-6 rounded-none border-2 border-primary bg-transparent text-[18px] font-normal appearance-none cursor-pointer"
                .value=${this.selected}
                @change=${this.onChange}
                style="background-image: url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e'); background-repeat: no-repeat; background-position: right 1.25rem center; background-size: 1.25rem; padding-right: 2.5rem;"
            >
                ${Array.isArray(this.cars) && this.cars.length > 0 ? this.cars.map(car => html`
                    <optgroup label="${car.model}">
                        ${car.variants.map(variant => html`
                            <option value="${variant.name}">${variant.name}</option>
                        `)}
                    </optgroup>
                `) : html`
                    <option value="Forester">Forester</option>
                    <option value="Solterra">Solterra</option>
                    <option value="Outback">Outback</option>
                    <option value="Crosstrek">Crosstrek</option>
                `}
            </select>
        `;
    }

    private onChange(e: Event) {
        const value = (e.target as HTMLSelectElement).value;
        this.selected = value;
        this.dispatchEvent(new CustomEvent('value-change', {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
}